import './phone-ext-field.scss';
import 'react-phone-number-input/style.css';

import {
  CreateBrokerField,
  CreateBrokerageField,
  CreateClaimantField,
  getCreateBrokerFieldProps,
  getCreateBrokerageFieldProps,
  getCreateClaimantFieldProps,
} from '@converge/data';

import { Box } from '@mui/material';
import { NewFormTextField } from './new-form-text-field';

type SupportedFieldTypes =
  | CreateBrokerageField
  | CreateBrokerField
  | CreateClaimantField;
export interface PhoneExtFieldProps {
  disabled?: boolean;
  dataTestId: string;
  dataExtTestId: string;
  autoComplete: boolean;
  mainClassName: string;
  className: string;
  classNameExt: string;
  placeholder: string;
  fieldPropsIdx: SupportedFieldTypes;
  fieldPropsExtIdx: SupportedFieldTypes;
  isContactpage?: boolean;
}

function isCreateBrokerageField(
  f: SupportedFieldTypes
): f is CreateBrokerageField {
  return Object.values(CreateBrokerageField).includes(
    f as CreateBrokerageField
  );
}

function isCreateBrokerField(f: SupportedFieldTypes): f is CreateBrokerField {
  return Object.values(CreateBrokerField).includes(f as CreateBrokerField);
}

function isCreateClaimantField(
  f: SupportedFieldTypes
): f is CreateClaimantField {
  return Object.values(CreateClaimantField).includes(f as CreateClaimantField);
}

export const PhoneExtField = ({
  disabled,
  isContactpage = false,
  dataTestId,
  dataExtTestId,
  autoComplete,
  mainClassName,
  className,
  classNameExt,
  placeholder,
  fieldPropsIdx,
  fieldPropsExtIdx,
}: PhoneExtFieldProps) => {
  const getFieldProps = (f: SupportedFieldTypes) => {
    if (isCreateClaimantField(f) && isContactpage) {
      return getCreateClaimantFieldProps(f);
    } else if (isCreateBrokerageField(f)) {
      return getCreateBrokerageFieldProps(f);
    } else if (isCreateBrokerField(f)) {
      return getCreateBrokerFieldProps(f);
    }
    // Fallback case - should not happen with proper typing
    return { name: f, label: f, containerWidth: 4 };
  };

  const propsMain = getFieldProps(fieldPropsIdx);
  const propsExt = getFieldProps(fieldPropsExtIdx);

  return (
    <Box className={mainClassName} style={{ maxHeight: '34px' }}>
      <NewFormTextField
        {...propsMain}
        className={className}
        placeholder={placeholder}
        dataTestId={dataTestId}
        isPhoneNumber
        disabled={disabled}
        autoComplete={autoComplete}
      />
      <NewFormTextField
        {...propsExt}
        className={classNameExt}
        label=""
        placeholder="Ext"
        dataTestId={dataExtTestId}
        disabled={disabled}
      />
    </Box>
  );
};
